import { LiveState, LiveStateEntry, PlaybackPath, StreamState } from "types/live-state";
import { LeaderboardActions, LeaderboardScoreForProfile } from "../../types/leaderboard";

const processLeaderboardActions = (
	collated: Map<string | LeaderboardActions, LeaderboardScoreForProfile>,
	action: LeaderboardScoreForProfile
) => {
	const existing = collated.get(action.action ?? action.custom_action);
	if (existing) {
		existing.score += action.score;
	} else {
		collated.set(action.action ?? action.custom_action, action);
	}
	return collated;
};

export const getLeaderboardActionsAggregatedByAction = (payload: LeaderboardScoreForProfile[]): LeaderboardScoreForProfile[] => {
	const mapped = payload.reduce(
		processLeaderboardActions,
		new Map<string | LeaderboardActions, LeaderboardScoreForProfile>()
	);

	return Array.from(mapped.values());
};

const isHlsPathname = (playbackUrl: string): playbackUrl is `/${string}.m3u8` => {
	return playbackUrl.startsWith("/") && playbackUrl.endsWith(".m3u8");
};

export const playbackUrlToPathname = (playbackUrl: string | null | undefined): PlaybackPath => {
	try {
		if (!playbackUrl) {
			console.warn("playbackUrl is null or undefined");
			return "/BADPATH.m3u8";
		}

		if (isHlsPathname(playbackUrl)) {
			return playbackUrl;
		}

		const url = new URL(playbackUrl ?? "");
		return url.pathname as `/${string}.m3u8`;
	} catch (e) {
		console.error(`Error parsing playbackUrl ${playbackUrl}: ${e}`);
		return "/BADPATH.m3u8";
	}
};

export const getPlaybackUrlLiveState = (liveStates: LiveState, playbackUrl: string | null | undefined): LiveStateEntry | undefined => {
	if (!playbackUrl) {
		return {
			state: StreamState.offline,
			liveAt: 0,
		};
	}
	return liveStates[playbackUrlToPathname(playbackUrl)];
};

